// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogFr = {
  "controls": {
    "boot": "Démarrer",
    "reset": "Réinitialiser",
    "copyScreen": "Copier l'Écran",
    "copyText": "Copier le texte",
    "pasteText": "Coller le Texte",
    "saveState": "Sauvegarder l'État",
    "restoreState": "Restaurer l'État",
    "toggleSound": "Basculer le Son",
    "retrySound": "Son indisponible. Réessayer le son.",
    "settings": "Paramètres",
    "debugPanel": "Panneau de Débogage",
    "infoPanel": "Panneau d'informations",
    "reportIssue": "Signaler un problème",
    "privacyPolicy": "Politique de confidentialité"
  },
  "config": {
    "speed": "Vitesse",
    "display": "Paramètres d'Affichage",
    "theme": "Thème",
    "openRetroControlPanel": "Panneau de commande",
    "resetSettings": "Réinitialiser Tous les Paramètres",
    "capsLock": "Verrouillage Majuscule",
    "useOpenApple": "Utiliser la touche {{modKey}} pour Open Apple",
    "useShortcuts": "Utiliser la touche {{modKey}} pour les raccourcis clavier",
    "useArrowKeys": "Utiliser les Flèches comme Joystick",
    "scanlines": "Lignes de Balayage CRT",
    "ghosting": "Rémanence du Phosphore",
    "crtDistortion": "Distorsion CRT",
    "joystick": "Configuration du joystick"
  },
  "machine": {
    "configuration": "Configuration de la Machine",
    "slotConfigurator": "Slots d'extension",
    "models": {
      "apple2p": "Apple II+",
      "apple2eu": "Apple IIe (non-amélioré)",
      "apple2ee": "Apple IIe (amélioré)"
    },
    "ram": {
      "64kb_aux": "64 KB (AUX)",
      "512kb": "512 KB",
      "1024kb": "1024 KB",
      "4mb": "4 MB",
      "8mb": "8 MB"
    }
  },
  "speed": {
    "snail": "Vitesse d'Escargot (0.1 MHz)",
    "slow": "Lente (0.5 MHz)",
    "normal": "Vitesse Normale (1 MHz)",
    "two": "2 MHz",
    "three": "3 MHz",
    "fast": "Rapide (4 MHz)",
    "warp": "Vitesse ridicule"
  },
  "colors": {
    "color": "Couleur",
    "nofringe": "Couleur (sans frange)",
    "green": "Vert",
    "amber": "Ambre",
    "white": "Noir et Blanc",
    "inverse": "Noir et Blanc (inverse)"
  },
  "timetravel": {
    "snapshotOnKeyPress": "Prendre une capture d'écran à l'appuie du bouton",
    "autoSnapshot": "Capture automatique",
    "auto_Off": "Désactivé",
    "auto_100k": "Toutes les 0,1s (100000 cycles)",
    "auto_1M": "Toutes les secondes (1M de cycles)"
  },
  "themes": {
    "classic": "Classique",
    "dark": "Sombre",
    "minimal": "Minimalisé"
  },
  "debug": {
    "helpPanel": "Afficher le panneau d'aide",
    "debugPanel": "Afficher le panneau de débogage",
    "expectinPanel": "Afficher le panneau Apple exPectin",
    "helpTab": "Aide",
    "debugTab": "Débogage",
    "breakpoints": "Points d'Arrêt",
    "memory": "Mémoire",
    "stack": "Pile",
    "state": "État du CPU",
    "registers": "Registres",
    "flags": "Drapeaux",
    "step": "Étape",
    "stepOver": "Enjamber",
    "stepInto": "Entrer",
    "stepOut": "Sortir",
    "resume": "Reprendre",
    "pause": "Pause",
    "loadSymbolTable": "Charger la table des symboles",
    "agentTab": "Agent",
    "disassembly": "Désassemblage",
    "basicLineNumber": "Nombre de la ligne BASIC:",
    "any": "Chaque"
  },
  "disassembly": {
    "memory": {
      "value": "Valeur: {{notation}}"
    },
    "keyboard": {
      "character": "Clavier: \"{{character}}\""
    },
    "display": {
      "altCharsetStatusOff": "Touches alternatives : Désactivées (MSB = 0)",
      "altCharsetStatusOn": "Touches alternatives : Activées (MSB = 1)",
      "mixedDisplayStatusOn": "Écrans mélangés: Activé (MSB = 1)"
    }
  },
  "tour": {
    "welcome": "Bienvenue dans l'émulateur Apple2TS !",
    "clickNext": "Pour en savoir plus, appuyez sur le bouton Suivant.",
    "bootButton": "Cliquez ici pour démarrer l'émulateur.",
    "resetButton": "Cliquez ici pour réinitialiser l'Apple II et redémarrer ou entrer dans BASIC.",
    "diskImages": "Choisissez une des images disque installées.",
    "floppyDisks": "Ou cliquez sur une des icônes de disquette pour charger une image disque.",
    "saveRestore": "Vous pouvez sauvegarder et restaurer l'état complet de l'émulateur avec ces boutons.",
    "themeButton": "Cliquez ici pour changer le thème de l'interface de l'émulateur.",
    "endTour": "Vous avez atteint la fin de la visite. Cliquez sur le bouton de visite du globe pour essayer une des autres visites, ou appuyez sur Terminer pour commencer à utiliser l'émulateur.",
    "tourSelectorHint": "Cliquez sur le bouton de visite du globe pour essayer l'une des autres visites, ou appuyez sur Terminer pour commencer à utiliser l'émulateur.",
    "settingsWelcome": "Apple2TS a un ensemble complet de contrôles pour l'émulateur et l'Apple II. Pour en savoir plus, appuyez sur le bouton Suivant.",
    "mainControls": "Ici, vous pouvez démarrer et réinitialiser l'Apple II, restaurer et sauvegarder l'état, copier l'écran, ou coller du texte dans l'émulateur.",
    "snapshot": "À tout moment, vous pouvez prendre un instantané de l'état actuel de l'émulateur, puis revenir en arrière à un état antérieur, ou avancer rapidement à nouveau. Vous pouvez aussi sauvegarder l'état de l'émulateur avec tous les instantanés actuels.",
    "pauseButton": "Vous pouvez mettre l'émulateur en pause à tout moment, gelant le processeur 6502. Ceci est utile pour mettre en pause l'action dans un jeu, ou entrer dans le débogueur.",
    "debugButton": "Cliquez sur l'insecte pour entrer en mode débogage, où vous pouvez voir l'état interne du processeur 6502. Cliquez à nouveau pour revenir au mode normal.",
    "configButtons": "La rangée du bas de boutons contrôle l'état de l'Apple II, en commençant par la vitesse de l'émulateur, la couleur de l'écran, et la mise en sourdine du son.",
    "keyboardButtons": "Si la touche de verrouillage majuscule est activée, alors tous les caractères tapés sont en MAJUSCULES.",
    "altArrowKeys": "La touche suivante détermine si la touche {{modKey}} est utilisée pour les raccourcis clavier ou la touche Open Apple de l'Apple II. La dernière touche détermine si les touches fléchées peuvent être utilisées comme joystick de l'Apple II.",
    "clearCookies": "Apple2TS sauvegarde automatiquement les paramètres actuels de l'émulateur comme cookies de navigateur. Appuyez sur ce bouton pour réinitialiser ces paramètres et supprimer les cookies.",
    "debugWelcome": "Apple2TS a un riche ensemble d'outils pour analyser et déboguer le code assembleur 6502. Pour en savoir plus, appuyez sur le bouton Suivant.",
    "debugIcon": "Cliquez sur l'icône Insecte dans les onglets Info pour voir le panneau de Débogage.",
    "debugPause": "Appuyez sur le bouton Pause pour mettre en pause ou reprendre l'exécution de l'émulateur.",
    "debugControls": "Maintenant que nous avons mis en pause, nous pouvons parcourir le code désassemblé en utilisant les boutons Enjamber, Entrer, et Sortir. Nous pouvons aussi sauter rapidement à l'adresse actuelle du Compteur de Programme (PC).",
    "debugDisassembly": "Ici nous voyons le code désassemblé, avec les adresses hexadécimales, l'instruction à trois lettres, et toutes valeurs ou adresses. Si vous déplacez votre souris sur une valeur verte, une info-bulle apparaîtra avec la valeur actuelle. Cliquer sur une adresse bleue défilera vers cet emplacement. Vous pouvez aussi cliquer dans la marge gauche pour ajouter ou supprimer des points d'arrêt.",
    "debugInfo": "Au milieu nous avons le Vidage de Pile et une Carte Mémoire. La Carte Mémoire se met à jour en temps réel et vous montre quelles banques mémoire sont actuellement actives.",
    "debugMemory": "La dernière section affiche la mémoire de l'Apple II. Vous pouvez utiliser la liste déroulante pour examiner différentes portions de mémoire. Si vous basculez vers une des pages HGR, vous obtiendrez une vue agrandie de l'écran haute résolution, liée aux emplacements mémoire. Vous pouvez aussi rechercher des valeurs hexadécimales ou des chaînes ASCII, et sauvegarder la mémoire dans un fichier.",
    "back": "Retour",
    "close": "Fermer",
    "last": "Terminer",
    "next": "Suivant",
    "nextLabelWithProgress": "Suivant (Étape {step} sur {steps})",
    "skip": "Fermer",
    "guidedTour": "Visite Guidée",
    "mainLabel": "Visite Guidée : Principal",
    "settingsLabel": "Visite Guidée : Paramètres",
    "debugLabel": "Visite Guidée : Débogage"
  },
  "disk": {
    "drive1": "Lecteur 1",
    "drive2": "Lecteur 2",
    "hardDisk": "Disque Dur",
    "eject": "Éjecter le Disque",
    "insert": "Insérer le Disque",
    "writeProtected": "Protégé en Écriture",
    "readWrite": "Lecture/Écriture",
    "empty": "Vide",
    "loading": "Chargement...",
    "selectDisk": "Sélectionner une Image Disque",
    "browse": "Parcourir",
    "newReleases": "Nouvelles Sorties",
    "writeProtectDisk": "Protection en Écriture du Disque",
    "saveDiskToDevice": "Sauvegarder le Disque",
    "saveDiskTo": "Sauvegarder le Disque sur",
    "saveDiskToMenu": "Sauvegarder le Disque sur >",
    "addToFavorites": "Ajouter aux Favoris",
    "downloadDisk": "Télécharger le Disque",
    "downloadWoz": "Télécharger l'image disque WOZ",
    "downloadAndEjectDisk": "Télécharger et Éjecter le Disque",
    "ejectDisk": "Éjecter le Disque",
    "ejectAllDisks": "Éjecter tous les disques",
    "saveDiskToOneDrive": "Sauvegarder le Disque sur OneDrive",
    "saveDiskToGoogleDrive": "Sauvegarder le Disque sur Google Drive",
    "loadDisk": "Charger le disque",
    "loadAdditionalDisks": "Charger un disque supplémentaire...",
    "loadDiskFrom": "Charger le Disque depuis",
    "loadDiskFromMenu": "Charger le Disque depuis >",
    "loadDiskFromDevice": "Charger le Disque",
    "loadDiskFromDeviceReadOnly": "Charger le Disque depuis l'Appareil (Lecture Seule)",
    "loadDiskFromDeviceReadWrite": "Charger le Disque depuis l'Appareil (Lecture/Écriture)",
    "loadDiskFromInternetArchive": "Charger le Disque depuis Internet Archive",
    "loadDiskFromOneDrive": "Charger le Disque depuis OneDrive",
    "loadDiskFromGoogleDrive": "Charger le Disque depuis Google Drive",
    "insertBlankDisk": "Insérer un disque vierge",
    "syncEveryMinute": "Synchroniser Chaque Minute",
    "syncEvery5Minutes": "Synchroniser Toutes les 5 Minutes",
    "pauseSyncing": "Suspendre la Synchronisation",
    "syncNow": "Synchroniser Maintenant",
    "modified": "modifié",
    "synced": "synchronisé",
    "diskImage": "Image de Disque",
    "diskDrivesAndDevices": "lecteurs de disque et périphériques",
    "syncedAt": "Synchronisé {{date}}",
    "clickToLoadDiskImage": "Cliquez pour charger l'image (ou les images) du disque",
    "clickToRemoveFromDiskCollection": "Cliquez pour supprimer de la collection de disques",
    "clickToAddToDiskCollection": "Cliquez pour ajouter à la collection de disques",
    "byCreator": "par {{creator}}",
    "clickToViewDetails": "Cliquez pour voir les détails",
    "standbyDisks": "Disques en attente (Cliquer pour changer de disque)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "Émulateur Apple IIe en TypeScript",
    "credit": "(c) {{year}} Chris Torrence et les contributeurs d’Apple2TS",
    "keyboardShortcuts": "Raccourcis Clavier",
    "shortcutsUnavailable": "Les raccourcis de l’émulateur avec {{keyMod}} ne sont pas disponibles tant que cette touche est affectée à Open Apple. Ctrl+0 à Ctrl+5 permettent toujours de sélectionner la vitesse de l’émulateur.",
    "diskImages": "Images disque :",
    "diskContainers": "Archives compressées :",
    "multiDiskNotice": "Changement multi-disque : Cliquez sur le badge multi-disque pour ouvrir le menu d'échange rapide. Les archives multi-disques (.zip, .7z, .gz) se montent automatiquement dans la liste d'échange.",
    "urlParameters": "Paramètres URL Optionnels",
    "examples": "Exemples",
    "mobileInstructions": "Plateformes mobiles :",
    "tapScreen": "Touchez l'écran pour afficher le clavier.",
    "arrowKeys": "Appuyez sur les touches fléchées, échap, ou tab pour envoyer ces touches à l'émulateur.",
    "ctrlKey": "Pour envoyer un caractère de contrôle, appuyez une fois sur le bouton ctrl. Puis touchez l'écran pour afficher le clavier et appuyez sur la touche désirée. Le bouton ctrl sera automatiquement relâché.",
    "ctrlLock": "Pour envoyer plusieurs caractères de contrôle, appuyez deux fois sur le bouton ctrl pour le verrouiller (indiqué par un point vert). Puis touchez l'écran pour afficher le clavier et appuyez sur les touches désirées. Appuyez à nouveau sur le bouton ctrl pour le relâcher.",
    "appleKeys": "Les touches open apple et closed apple se comportent de la même façon que la touche ctrl.",
    "openAppleKey": "Open Apple: Alt/Option Gauche",
    "closedAppleKey": "Closed Apple: Alt/Option Droite",
    "joystickKeys": "Touches Joystick: Pavé num 8/2/4/6 (7/9/1/3), 0/5, ./Entrée",
    "onScreenKeyboard": "Pour le clavier à l'écran, pour CTRL ou ESC :\nappuyer une fois pour activer puis la touche souhaitée.",
    "urlParametersBody": "Pour les paramètres d'URL optionnels, ajoutez-les à l'URL après un point d'interrogation (?) et séparez plusieurs paramètres par une esperluette (&). Utilisez # pour spécifier l'image disque. Consultez la boîte de dialogue du Générateur de liens pour des exemples.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay avec débogage",
      "totalReplayChoplifter": "Total Replay, charger Choplifter, mode intégré",
      "a2Desktop": "A2DeskTop 2MG avec vitesse rapide et couleur",
      "embeddedBasic": "Programme Applesoft BASIC Intégré",
      "binaryHexAddress": "Fichier binaire avec adresse hexadécimale"
    },
    "links": "Liens",
    "resourceLinks": {
      "desktopApp": "Application de bureau Apple2TS",
      "corsProxy": "Proxy CORS par Corsfix",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "on": "activé",
    "off": "désactivé",
    "confirmTheme": "Recharger l'émulateur et appliquer ce thème maintenant ?",
    "confirmReset": "Réinitialiser tous les paramètres aux valeurs par défaut ?",
    "fileNotFound": "Fichier non trouvé",
    "invalidFile": "Format de fichier invalide",
    "diskInserted": "Disque inséré",
    "diskEjected": "Disque éjecté"
  },
  "keyboard": {
    "capsLock": "Verrouillage Majuscule",
    "shift": "Maj",
    "escape": "Échap",
    "enter": "Entrée",
    "space": "Espace",
    "backspace": "Effacement",
    "delete": "Supprimer",
    "return": "Retour"
  },
  "audio": {
    "speaker": "Haut-parleur",
    "midi": "MIDI",
    "configuration": "Configuration audio",
    "mute": "Muet",
    "waveform": "Forme d'Onde"
  },
  "print": {
    "printer": "Imprimante",
    "print": "Imprimer",
    "clear": "Effacer",
    "save": "Sauvegarder la Sortie",
    "dumpScreen": "Copier l'écran actuel vers l'imprimante",
    "dumpScreenInverse": "Copier l'écran actuel (Inversé)",
    "sendToPrinter": "Envoyer à l'imprimante",
    "tearOff": "Arracher la page et réinitialiser",
    "printedPage": "Page imprimée",
    "printerConfig": "Configuration de l'imprimante",
    "pageLength": "Longueur de page",
    "pageLengthLetter": "11 pouces (Lettre)",
    "pageLengthA4": "11,7 pouces (A4)",
    "pageLengthTwelve": "12 pouces"
  },
  "device": {
    "machineConfiguration": "Configuration de la Machine",
    "midiDeviceSelect": "Sélection de Périphérique MIDI",
    "serialPortSelect": "Sélection de Port Série",
    "mockingboardWaveform": "Forme d'Onde Mockingboard"
  },
  "collection": {
    "showApple2TSCollection": "Afficher la Collection Apple2TS",
    "showNewReleases": "Afficher les nouvelles sorties",
    "showFavorites": "Afficher les favoris",
    "chooseDiskImage": "Choisir l'image de disque",
    "diskCollection": "Collection de disques",
    "clickToShowDetails": "Cliquer pour afficher les détails de",
    "clickToLoadDisk": "Cliquer pour charger le disque",
    "diskIsNewRelease": "Le disque est une nouvelle sortie",
    "diskIsApple2TSCollection": "Le disque fait partie de la collection Apple2TS",
    "diskIsInternetArchive": "Le disque fait partie d'Internet Archive",
    "clickToRemoveFromCollection": "Cliquer pour retirer de la collection de disques",
    "clickToKeepInCollection": "Clicker pour garder dans la collection de disques",
    "clickToAddToCollection": "Cliquez pour ajouter à la collection de disques",
    "diskIsSyncedVia": "Le disque est synchronisé via",
    "loadDiskIntoDrive": "Charger le Disque dans le Lecteur",
    "exportDisksToHdv": "Exporter les disques en HDV",
    "export": "Exporter",
    "clickToRemoveFromSelected": "Cliquer pour retirer des disques sélectionnés",
    "clickToAddToSelected": "Cliquer pour ajouter aux disques sélectionnés",
    "reportExportIssue": "Signaler un problème d'exportation"
  },
  "debugControls": {
    "goBackInTime": "Remonter dans le Temps",
    "takeSnapshot": "Prendre un Instantané",
    "goForwardInTime": "Avancer dans le Temps",
    "saveStateWithSnapshots": "Sauvegarder l'État avec les Instantanés",
    "resume": "Reprendre",
    "pause": "Suspendre",
    "tracing": "Tracer",
    "downloadTraceLog": "Télécharger le journal de trace"
  },
  "fullscreen": {
    "fullScreen": "Plein Écran"
  },
  "internetArchive": {
    "searchPlaceholder": "Entrez le nom d'un logiciel ou cliquez sur une des catégories ci-dessus"
  },
  "basic": {
    "newProgram": "Nouveau programme",
    "runFromBeginning": "Exécuter depuis le début",
    "break": "Interrompre",
    "continueRunning": "Continuer l'exécution",
    "stepProgram": "Exécuter le programme pas à pas",
    "resumeOutput": "Reprendre la sortie",
    "freezeOutput": "Figer la sortie",
    "importProgram": "Importer le programme...",
    "exportProgram": "Exporter le programme...",
    "renumberProgram": "Renuméroter le programme",
    "rebuildProgram": "Reconstruire le programme depuis la mémoire",
    "displaySettings": "Paramètres d'affichage",
    "autoLineNumbering": "Numérotation automatique des lignes",
    "capitalizeKeywords": "Mettre les mots-clés en majuscules",
    "rebuildWarning": "Ceci remplacera le programme actuel par une version reconstruite depuis la mémoire de l'Apple II. Vous perdrez toutes les modifications non enregistrées. Êtes-vous sûr ?",
    "value": "Valeur"
  },
  "expectin": {
    "runScript": "Exécuter le script",
    "stopScript": "Arrêter le script"
  },
  "saveDisassembly": {
    "title": "Enregistrer le désassemblage",
    "startAddress": "Adresse de début $",
    "endAddress": "Adresse de fin $",
    "includeLabels": "Incluir les étiquettes de symboles",
    "separatorLines": "Lignes de séparation après JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Flèches comme joystick",
    "siriusJoyport": "Mode Sirius Joyport"
  },
  "traceSettings": {
    "title": "Paramètres de trace",
    "ignoreRegisters": "Ignorer les valeurs quand les lignes se répètes",
    "settings": "Paramètres"
  },
  "linkBuilder": {
    "startupOptionsTab": "Options de démarrage",
    "textToType": "Texte pour écrire après avoir chargés les disques :",
    "speedNames": {
      "warp": "Ridicule"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "Configurer les cartes d'extension",
      "slot": "Slot {{slot}}:",
      "cardNone": "Aucune (vide)"
    },
    "additionalDiskDrives": "Lecteurs de disque supplémentaires",
    "slot6Drive1": "Emplacement 6 Lecteur 1 (Disquette 1)",
    "slot6Drive2": "Emplacement 6 Lecteur 2 (Disquette 2)",
    "slot7Drive1": "Emplacement 7 Lecteur 1 (Disque dur 1)",
    "slot7Drive2": "Emplacement 7 Lecteur 2 (Disque dur 2)",
    "slot2Drive1": "Emplacement 2 Lecteur 1 (VERA SD)",
    "slot4Drive1": "Emplacement 4 Lecteur 1 (VERA SD)",
    "addAdditionalDisk": "Ajouter un disque supplémentaire pour l'échange",
    "removeDisk": "Supprimer ce disque",
    "addAnotherDisk": "Ajouter un autre disque",
    "diskPlaceholder": "Nom du fichier du disque {num} (ex. sideB.woz|Disque de scénario)"
  },
  "startup": {
    "welcome": "Bienvenue sur Apple2TS",
    "subtitle": "Émulateur Apple II en TypeScript",
    "copyright": "(c) {{year}} C.Torrence + collaborateurs",
    "diskCollections": "Cliquez sur l'icône\nCollections de Disques\npour charger un disque\nou un jeu intégré."
  },
  "retroControl": {
    "machine": "Machine",
    "fullscreen": "Plein écran",
    "diskCollection": "Disques",
    "diskDrives": "Lecteurs de disque",
    "display": "Affichage",
    "monitorMode": "Mode du moniteur",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Son",
    "options": "Options",
    "skin": "Apparence",
    "personalization": "Personnalisation",
    "text": "Texte",
    "background": "Arrière-plan",
    "border": "Bordure",
    "iigsColor": {
      "black": "Noir",
      "red": "Rouge",
      "darkBlue": "Bleu foncé",
      "purple": "Violet",
      "darkGreen": "Vert foncé",
      "darkGray": "Gris foncé",
      "mediumBlue": "Bleu moyen",
      "lightBlue": "Bleu clair",
      "brown": "Marron",
      "orange": "Orange",
      "lightGray": "Gris clair",
      "pink": "Rose",
      "lightGreen": "Vert clair",
      "yellow": "Jaune",
      "aquamarine": "Aigue-marine",
      "white": "Blanc"
    },
    "keyboard": "Clavier",
    "joystick": "Manette",
    "slots": "Emplacements",
    "devices": "Périphériques",
    "printerPort": "Port imprimante",
    "modemPort": "Port modem",
    "quit": "Quitter",
    "apple2tsCollection": "Collection Apple2TS",
    "newReleases": "Nouveautés",
    "favorites": "Favoris",
    "exportDisksToHdv": "Exporter les disques vers HDV",
    "noDiskDrivesAvailable": "Aucun lecteur de disque disponible",
    "select": "Sélectionner",
    "open": "Ouvrir",
    "load": "Charger",
    "go": "Aller",
    "save": "Enregistrer",
    "clipboard": "Presse-papiers",
    "cancelEsc": "Annuler:Esc",
    "color": "Couleur",
    "systemSpeed": "Vitesse du système",
    "other": "Autres",
    "timeMachine": "Instantanés",
    "ports": "Ports",
    "language": "Langue",
    "retroTheme": "Rétro",
    "lowercaseInput": "Saisie en minuscules",
    "openAppleKey": "Touche Pomme ouverte",
    "sortOrder": "Tri",
    "card": {
      "empty": "Vide",
      "mockingboard": "Mockingboard"
    }
  }
}
